<template>
  <div ref="page" class="page-loading"
       @touchmove.stop="">
    <div v-if="!isLoaded"
         class="box-loading">
      <template v-if="isLoadingLoaded">
        <div class="loading-ip"></div>
        <div class="loading-progress">
          <div class="loading-progress-bg">
            <div class="loading-progress-ico"
                 :style="`transform: translate(${cptIco}, -50%);`"></div>
          </div>
          <div class="loading-chest"
               :style="`transform: translate(${cptChest}, -50%);`">
          </div>
        </div>
        <div class="loading-text">
        </div>
      </template>
    </div>
    <div v-else
         class="box-start">
      <div class="loading-logo">
      </div>
      <div class="loading-title">
      </div>
      <div class="loading-start"
           @click="start">
      </div>
    </div>
  </div>
</template>

<script>
import { px2rem } from '@/utils'
import Loader from '@/utils/loader'
export default {
  components: {},
  data() {
    return {
      loadnum: 0,
      isLoadingLoaded: false,
      isLoaded: false,
      isShowIndex: false
    }
  },
  computed: {
    cptIco() {
      return px2rem(544 * this.loadnum / 100 + 30)
    },
    cptChest() {
      return px2rem(544 * this.loadnum / 100)
    }
  },
  async created() {
    setTimeout(() => {
      Loader.load('loading', {
        success: (e) => {
          console.debug('Resource Loading Success', e)
        },
        fail: (e) => {
          console.debug('Resource Loading Fail', e)
        },
        complete: () => {
          this.isLoadingLoaded = true
          // IOS 加载完后堵塞  图片渲染
          setTimeout(() => {
            this.load()
          }, 50)
        }
      })
    }, 0)
  },
  mounted() {
  },
  methods: {
    load() {
      Loader.load('main', {
        process: (loaded, total) => {
          this.loadnum = loaded / total * 100
        },
        success: (e) => {
          console.debug('Resource Success', e)
        },
        fail: (e) => {
          console.debug('Resource Fail', e)
        },
        complete: () => {
          console.debug('Resource Complete')
          if (this.isShowIndex) {
            this.isLoaded = true
          } else {
            this.start()
          }
        }
      })
    },
    start() {
      document.body.removeChild(this.$refs.page)
      this.onOk && this.onOk()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-loading {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  touch-action: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .box-loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    touch-action: none;
    background-color: #eb7a00;
    .loading-ip {
      width: 88px;
      height: 207px;
      background-image: url("../../assets/loading/loading-ip.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .loading-progress {
      margin-top: 7px;
      position: relative;
      background-color: #e04f00;
      height: 42px;
      border-radius: 42px;
      border: 2px solid #953604;
      width: 594px;
      // overflow: hidden;
      .loading-progress-bg {
        position: absolute;
        top: 4px;
        right: 4px;
        bottom: 4px;
        left: 4px;
        content: "";
        display: block;
        background-color: #f6b200;
        border-radius: 34px;
        overflow: hidden;
        .loading-progress-ico {
          position: absolute;
          top: 50%;
          left: -100%;
          transform: translate(0, -50%);
          width: 100%;
          height: 46px;
          background-image: url("../../assets/loading/loading-progress.png");
          background-size: auto 46px;
          background-repeat: repeat-x;
          z-index: 10;
        }
      }
      .loading-chest {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        width: 70px;
        height: 70px;
        background-image: url("../../assets/loading/loading-chest.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        z-index: 20;
      }
    }
    .loading-text {
      margin-top: 18px;
      width: 148px;
      height: 42px;
      background-image: url("../../assets/loading/loading-text.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
  }
  .box-start {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    background-image: url("../../assets/loading/loading-bg.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center;
    .loading-logo {
      position: absolute;
      top: 26px;
      left: 50%;
      transform: translateX(-50%);
      width: 697px;
      height: 55px;
      background-image: url("../../assets/loading/loading-logo.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .loading-title {
      position: absolute;
      top: 73px;
      left: 50%;
      transform: translateX(-50%);
      width: 624px;
      height: 242px;
      background-image: url("../../assets/loading/loading-title.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .loading-start {
      position: absolute;
      bottom: 101px;
      left: 50%;
      transform: translateX(-50%);
      width: 479px;
      height: 95px;
      background-image: url("../../assets/loading/loading-start.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
  }
}
</style>